const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://qhqg-api.cgis.asia/",
        domainAdminSite: "http://localhost:3000",
        domainUserSide: "http://localhost:3000",
        domainName: "",
  },
  production: {
      api: "https://qhqg-api.cgis.asia/",
      domainAdminSite: "https://admin.qhqg.cgis.asia",
      domainUserSide: "https://admin.qhqg.cgis.asia",
      domainName: "qhqg.cgis.asia",
  },
};

module.exports = apiEnvironment[env];
